<template>
  <div :class="['w-full px-4 md:px-6 py-5 rounded', backgroundColor, fullWidth ? 'w-full' : 'max-w-[784px]']">
    <div :class="['flex w-full gap-3 ']" :data-information-box-type="type">
      <div v-if="!!icon && !hideIcon" class="w-6 h-6 flex-col justify-center content-center gap-2.5 flex-shrink-0">
        <img :src="icon" :alt="`${type} icon`" class="w-4 h-4" />
      </div>
      <div class="flex content-center">
        <span class="cursor-pointer text-racq-dark-grey text-base-bold" @click="expanded = !expanded">{{ title }}</span>
      </div>
      <div class="flex-col flex-grow content-center items-end">
        <ShowHideButton
          class="float-right !mt-0 md:hidden"
          :showMore="expanded"
          showMoreLabel=""
          showLessLabel=""
          appendClass="relative"
          @click="expanded = !expanded"
        ></ShowHideButton>
        <ShowHideButton
          class="float-right !mt-0 hidden md:flex"
          :showMore="expanded"
          :showMoreLabel="showMoreText"
          :showLessLabel="showLessText"
          @click="expanded = !expanded"
        ></ShowHideButton>
      </div>
    </div>
    <div class="flex flex-col gap-4">
      <div v-if="!$slots.infoBoxContent && description && expanded" class="flex flex-row mt-4">
        <div class="text-dark-grey-text text-m" v-html="description"></div>
      </div>
      <div v-if="!$slots.infoBoxContent && links && expanded" class="flex flex-row">
        <ul class="list-none">
          <li class="m-auto m-1 md:inline-block">
            <a
              v-for="(link, index) in links"
              :key="index"
              :href="link.url"
              class="text-m mr-5 mt-5"
              :class="getButtonClasses(link)"
              v-html="link.title"
            ></a>
          </li>
        </ul>
      </div>
      <div v-if="$slots.buttons">
        <slot v-if="$slots.buttons && expanded" name="buttons"> [Named slot for info box content (buttons)]</slot>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { IInformationBox, LinkTypes } from '@/interfaces/forms/information-box.interface';
import { computed } from 'vue';
import ShowHideButton from '../ShowHideButton/ShowHideButton.vue';

export interface INotification extends IInformationBox {
  showMoreText: string;
  showLessText: string;
  fullWidth?: boolean;
  openByDefault?: boolean;
}

const props = defineProps<INotification>();

const expanded = ref<boolean>(props.openByDefault);

const iconMap = {
  info: require('@/assets/icons/info-information.svg'),
  warning: require('@/assets/icons/info-warning.svg'),
  error: require('@/assets/icons/info-error.svg'),
  success: require('@/assets/icons/info-success.svg'),
  marketing: require('@/assets/icons/info-marketing.svg'),
};

const backgroundColorMap = {
  info: 'bg-racq-info-light-blue',
  warning: 'bg-racq-info-light-yellow',
  error: 'bg-racq-info-light-red',
  success: 'bg-racq-info-light-green',
  marketing: 'bg-racq-light-purple',
};

function getButtonClasses(link: any) {
  if (!link) return '';

  switch (link.type) {
    case LinkTypes.BUTTON_PRIMARY:
      return 'btn btn-primary';

    case LinkTypes.BUTTON_SECONDARY:
      return 'btn btn-secondary';
  }
}

const icon = computed(() => iconMap[props.type]);
const backgroundColor = computed(() => backgroundColorMap[props.type]);
</script>
